import React, { useContext, useEffect } from "react";
import { authentication } from "../../store/firebase-config";
import styles from "./Profile.module.css";
import { useLocation, useNavigate } from "react-router";
import signOut from "../../assests/popup/signOut.svg";

import LoadingFromCenter from "../LoadingFromCenter/LoadingFromCenter";
import Context from "../../context/Context";
import { useUserAuth } from "../../context/UserAuthContext";
import { createSearchParams } from "react-router-dom";
const Signout = ({ setSignOut }) => {
  let organizerID = window.location.href.split("/")[3];
  let campainID = window.location.href.split("/")[4];
  const { setCurrentUser, setGuestModeEnabled, searchParams } = useUserAuth();
  const { preview, buildType } = useContext(Context);
  const navigate = useNavigate();
  // console.log(currentUser);
  const location = useLocation();
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);
  return (
    <div className="fixed top-0 left-0 w-[100%] h-[100%] flex items-center justify-center p-[20px] z-100 text-center z-10">
      <div className={styles.deteleme}>
        <img src={signOut} alt="" className="w-[56px] h-[56px] mb-[24px]" />
        <p className="text-regular-medium px-[20px] mb-[16px]">
          Are you sure want to sign out from{" "}
          {buildType == "highonevent" ? "High on Event" : "Goviral"}?
        </p>
        <p className="text-small text-[#CDCDCD] px-[20px]">
          You can come back any time.
        </p>
        <div className="seperator my-[20px]" />
        <div className="flex flex-col gap-[16px] w-[100%] cursor-pointer">
          <button
            className={styles.signOutButton}
            onClick={() => {
              authentication.signOut();
              localStorage.removeItem("uniqueId");
              setCurrentUser({});
              setGuestModeEnabled(true);
              if (preview) {
                navigate({
                  pathname: location?.state?.previousLocation,
                  search: "?preview=true",
                });
              } else {
                navigate({
                  pathname: location?.state?.previousLocation,
                  search: `${
                    searchParams ? createSearchParams(searchParams) : ""
                  }`,
                });
              }
            }}
          >
            <p className="text-regular-medium">Signout</p>
          </button>
          <div onClick={() => setSignOut(false)}>
            <p>Cancel</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Signout;
